var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArticleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.47024 9.08859H9.84035V7.86142H5.47024V9.08859ZM5.47024 7.29579H13.1841V6.06863H5.47024V7.29579ZM5.47024 5.503H13.1841V4.27582H5.47024V5.503ZM4.12913 13.3644C3.72054 13.3644 3.36945 13.2176 3.07589 12.924C2.78232 12.6305 2.63553 12.2794 2.63553 11.8708V1.50427C2.63553 1.09274 2.78232 0.739149 3.07589 0.443489C3.36945 0.14783 3.72054 0 4.12913 0H14.4957C14.9073 0 15.2608 0.14783 15.5565 0.443489C15.8522 0.739149 16 1.09274 16 1.50427V11.8708C16 12.2794 15.8522 12.6305 15.5565 12.924C15.2608 13.2176 14.9073 13.3644 14.4957 13.3644H4.12913ZM4.12913 11.8708H14.4957V1.50427H4.12913V11.8708ZM1.50427 16C1.09275 16 0.739152 15.8521 0.443491 15.5564C0.14783 15.2608 0 14.9072 0 14.4957V2.63552H1.50427V14.4957H13.3645V16H1.50427Z",
    fill: "#A5A4BF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArticleIcon);
export default __webpack_public_path__ + "static/media/article_icon.a059c0481cfbade1a14d427ad7aa90de.svg";
export { ForwardRef as ReactComponent };